var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef } from "react";
import { Dropdown, ResponsiveMode, Toggle, PrimaryButton, MessageBar, MessageBarType, ComboBox } from "@fluentui/react";
import './SharedGrid.css';
import PlacementApiSearchService from "../service/PlacementApiSearchService";
import AuthService from "../service/AuthService";
const dropdownStyles = {
    dropdown: {
        width: "100%",
        boxShadow: "0 0px 4px rgba(0, 0, 0, 0.2)",
        borderRadius: 4,
        backgroundColor: "transparent",
        borderBottom: "3px #242424",
    },
};
const BUProductsSection = ({ 
//selectedProduct,
selectedBU, 
//optionsProducts,
optionsBU, 
//onProductChange,
selectedLOB, selectedSubLOB, optionsLOB, optionsSubLOB, onLOBChange, onSubLOBChange, onBUChange, sendCopyToCyberAdmin, assignIngestionToSelf, onSendCopyToggle, onAssignIngestionToggle, onSubmit, emailSubject, isDraftEmail, fileValidationError, isSubmitDisabled: externalIsSubmitDisabled, isUpdateMode, }) => {
    // Check if submit button should be disabled
    const isSubmitDisabled = externalIsSubmitDisabled || !selectedLOB || !selectedSubLOB || (isDraftEmail && (!emailSubject || emailSubject.trim() === ''));
    const [placements, setPlacements] = useState([]);
    const [selectedPID, setSelectedPID] = useState("");
    const comboRef = useRef(null);
    // Sub‑LOB → Product Code mapping
    const SUBLOB_TO_PRODUCT_MAP = {
        // Product 20001
        "106203": "20001",
        // Product 10012
        "104202": "10012",
        // Product 10013
        "104205": "10013",
        // Product 20002
        "110201": "20002",
        "110202": "20002",
        "110203": "20002",
        // Product 10022
        "101202": "10022",
    };
    ``;
    const fetchPlacements = (inputValue) => __awaiter(void 0, void 0, void 0, function* () {
        if (inputValue.trim() === "") {
            setPlacements([]);
            return;
        }
        try {
            let apiTokenSearch = "";
            yield AuthService.getApiToken().then(value => {
                apiTokenSearch = (value === null || value === void 0 ? void 0 : value.accessToken) || "";
            });
            const response = yield PlacementApiSearchService.searchPlacementID(apiTokenSearch, {
                productCode: SUBLOB_TO_PRODUCT_MAP[selectedSubLOB], //selectedProduct
                searchString: inputValue,
            });
            const options = response.map((placement) => ({
                key: placement.placementId,
                text: placement.placementId,
                insurerName: placement.insuredName,
                brokerName: placement.broker,
            }));
            setPlacements(options);
        }
        catch (error) {
            console.error("Error fetching placements:", error);
        }
    });
    const handleInputValueChange = (text) => {
        var _a;
        // Clear placements if the input is empty
        if (text.trim() === "") {
            setPlacements([]);
            return;
        }
        // Trigger API call only when the input length is 2 or more characters
        if (text.length >= 2) {
            fetchPlacements(text); // Fetch placements based on the input
        }
        else {
            setPlacements([]); // Clear placements when less than 2 characters
        }
        (_a = comboRef.current) === null || _a === void 0 ? void 0 : _a.focus(true);
    };
    const onPIDChange = (_, option) => {
        var _a;
        setSelectedPID((_a = option === null || option === void 0 ? void 0 : option.key) === null || _a === void 0 ? void 0 : _a.toString());
    };
    return (_jsxs("div", { className: "ms-Grid", dir: "ltr", id: "maindiv", children: [fileValidationError && (_jsx("div", { className: "ms-Grid-row", style: { marginBottom: '16px' }, children: _jsx("div", { className: "ms-Grid-col ms-sm12", children: _jsx(MessageBar, { messageBarType: MessageBarType.error, isMultiline: true, styles: {
                            root: {
                                backgroundColor: '#fdf2f2',
                                border: '1px solid #d13438',
                                borderRadius: '4px',
                            },
                            content: {
                                display: 'flex',
                                alignItems: 'flex-start',
                            },
                            icon: {
                                color: '#d13438',
                            },
                            text: {
                                color: '#d13438',
                                fontWeight: '500',
                            }
                        }, children: fileValidationError === null || fileValidationError === void 0 ? void 0 : fileValidationError.split('\n').map((line, index) => {
                            // Style the main message differently
                            if (index === 0) {
                                return (_jsx("div", { style: {
                                        marginBottom: '8px',
                                        fontWeight: '600'
                                    }, children: line }, index));
                            }
                            // Style bullet points
                            return (_jsx("div", { style: {
                                    marginLeft: '16px',
                                    marginBottom: '4px'
                                }, children: line }, index));
                        }) }) }) })), _jsxs("div", { className: "ms-Grid savesection", children: [_jsx("div", { className: "ms-Grid-row", children: _jsx("div", { className: "ms-Grid-col ms-sm12 ms-md6 ms-lg6 paddingtopalldivs", children: _jsx(Dropdown, { label: "Line of Business", selectedKey: selectedLOB, defaultSelectedKey: selectedLOB, options: optionsLOB, disabled: isUpdateMode, styles: Object.assign(Object.assign({}, dropdownStyles), { dropdown: {
                                        backgroundColor: "transparent",
                                        cursor: "default",
                                    }, label: { color: "#000000" }, title: {
                                        backgroundColor: "transparent",
                                        color: "#323130",
                                        border: "1px solid #8A8886",
                                    }, caretDown: { color: "#605E5C" } }), responsiveMode: ResponsiveMode.large, onChange: onLOBChange, calloutProps: {
                                    directionalHint: 4,
                                    isBeakVisible: false,
                                    doNotLayer: true,
                                } }) }) }), _jsx("div", { className: "ms-Grid-row", children: _jsx("div", { className: "ms-Grid-col ms-sm12 ms-md6 ms-lg6 paddingtopalldivs", children: _jsx(Dropdown, { label: "Sub Line of Business", selectedKey: selectedSubLOB, defaultSelectedKey: selectedSubLOB, options: optionsSubLOB, disabled: isUpdateMode, styles: Object.assign(Object.assign({}, dropdownStyles), { dropdown: {
                                        backgroundColor: "transparent",
                                        cursor: "default",
                                    }, label: { color: "#000000" }, title: {
                                        backgroundColor: "transparent",
                                        color: "#323130",
                                        border: "1px solid #8A8886",
                                    }, caretDown: { color: "#605E5C" } }), responsiveMode: ResponsiveMode.large, onChange: onSubLOBChange, calloutProps: {
                                    directionalHint: 4,
                                    isBeakVisible: false,
                                    doNotLayer: true,
                                } }) }) }), _jsx("div", { className: "ms-Grid-row", children: _jsx("div", { className: "ms-Grid-col ms-sm12 ms-md6 ms-lg6 paddingtopalldivs", children: _jsx(Dropdown, { label: "Business Unit", selectedKey: selectedBU, options: optionsBU, disabled: true || isUpdateMode, styles: Object.assign(Object.assign({}, dropdownStyles), { dropdown: {
                                        backgroundColor: "transparent",
                                        cursor: "default",
                                    }, label: { color: "#000000" }, title: {
                                        backgroundColor: "transparent",
                                        color: "#323130",
                                        border: "1px solid #8A8886",
                                    }, caretDown: { color: "#605E5C" } }), calloutProps: {
                                    directionalHint: 4,
                                    isBeakVisible: false,
                                    doNotLayer: true,
                                }, onChange: onBUChange }) }) }), isUpdateMode && (_jsx("div", { className: "ms-Grid-row", children: _jsx("div", { className: "ms-Grid-col ms-sm12 ms-md6 ms-lg6 paddingtopalldivs", children: _jsx(ComboBox, { label: "Placement ID", componentRef: comboRef, placeholder: "Search for Placement ID / Insured", selectedKey: selectedPID, onInputValueChange: handleInputValueChange, allowFreeform: true, autoComplete: "on", options: placements, styles: {
                                    root: { width: "100%", position: "relative", backgroundColor: "transparent" },
                                    input: { paddingRight: 60 },
                                    callout: { minWidth: "100%" },
                                }, onChange: onPIDChange, onRenderOption: (option) => {
                                    const opt = option;
                                    return (_jsxs("div", { style: { lineHeight: "1.4", padding: "4px 8px" }, children: [_jsx("div", { style: { fontWeight: 600, color: "#323130" }, children: opt.text }), opt.insurerName && (_jsx("div", { style: { fontSize: 12, color: "#605E5C" }, children: opt.insurerName })), opt.brokerName && (_jsx("div", { style: { fontSize: 12, color: "#605E5C" }, children: opt.brokerName }))] }));
                                } }) }) })), (selectedLOB === "106000") && ( //selectedProduct === "20001" // || selectedLOB === "110000"
                    _jsxs(_Fragment, { children: [_jsx("h3", { style: { marginBottom: 10, padding: "5px 4px" }, children: "Shared Mailbox" }), _jsx("div", { style: { marginTop: 0 }, children: _jsx(Toggle, { inlineLabel: true, label: "Send a copy to MRSL457-CyberAdmin-(Pool)", checked: sendCopyToCyberAdmin, onChange: onSendCopyToggle, styles: {
                                        root: { marginLeft: 2 },
                                        label: { fontWeight: "semibold", color: "#242424" },
                                    } }) })] })), (selectedLOB !== "106000") && (_jsx("div", { style: { marginTop: 12 } })), _jsx("div", { className: "ms-Grid-row", children: _jsx("div", { className: "ms-Grid-col ms-sm12 ms-md6 ms-lg6", children: _jsx("div", { style: { marginTop: 0, marginBottom: 20 }, children: _jsx(Toggle, { inlineLabel: true, label: "Assign Ingestion Record to Myself", checked: assignIngestionToSelf, onChange: onAssignIngestionToggle, styles: {
                                        root: { marginLeft: 2 },
                                        label: { fontWeight: "semibold", color: "#242424" },
                                    } }) }) }) }), isDraftEmail && isSubmitDisabled && (_jsx("div", { style: {
                            marginBottom: 10,
                            padding: "8px 12px",
                            color: "#d13438",
                            fontSize: "13px",
                            backgroundColor: "#fde7e9",
                            border: "1px solid #d13438",
                            borderRadius: "4px",
                            fontWeight: "500"
                        }, children: "\u26A0\uFE0F Please add a subject to your email before submitting" })), (!selectedLOB || !selectedSubLOB) && (_jsx("div", { style: {
                            marginBottom: 10,
                            padding: "8px 12px",
                            color: "#605E5C",
                            fontSize: "13px",
                            backgroundColor: "#f3f2f1",
                            border: "1px solid #c8c6c4",
                            borderRadius: "4px"
                        }, children: "\u26A0\uFE0F Please select both Line of Business and Sub Line of Business" })), _jsx("div", { className: "ms-Grid-row attachmentdiv", children: _jsx("div", { className: "ms-Grid-col ms-sm3 ms-md2 ms-lg2 savebuttonmargin", children: _jsx(PrimaryButton, { className: "bottomLeftButton", text: "Submit", type: "submit", onClick: onSubmit, disabled: isSubmitDisabled, styles: {
                                    root: {
                                        width: 100,
                                        height: 40,
                                        fontWeight: "bold",
                                        backgroundColor: isSubmitDisabled ? "#8A8886" : "#0F1E32",
                                        borderRadius: 4,
                                        opacity: isSubmitDisabled ? 0.6 : 1,
                                        cursor: isSubmitDisabled ? "not-allowed" : "pointer",
                                    },
                                    rootHovered: {
                                        backgroundColor: isSubmitDisabled ? "#8A8886" : "#0F1E32",
                                        opacity: isSubmitDisabled ? 0.6 : 1,
                                    },
                                    rootPressed: {
                                        backgroundColor: isSubmitDisabled ? "#8A8886" : "#0F1E32",
                                        opacity: isSubmitDisabled ? 0.6 : 1,
                                    },
                                } }) }) })] })] }));
};
export default BUProductsSection;
